import type { ImportFieldsFragment, ImportSummaryQuery } from '@frontend/graphql/queries/imports.generated'
import { ImportFailureKind, ImportType, ImportStatus } from '@frontend/graphql/types.generated'

export { ImportFailureKind, ImportType, ImportStatus }

export type Import = ImportFieldsFragment

export type ImportCounts = NonNullable<Import['counts']>

export type SummaryImport = NonNullable<ImportSummaryQuery['import']>

export type ImportFailure = SummaryImport['failures'][number]

export type ImportWarning = SummaryImport['warnings'][number]

export type ImportSummaryData = {
  import: SummaryImport
  canDownload: boolean
}

const SETTLED_STATUSES = [ImportStatus.Completed, ImportStatus.CompletedWithFailures, ImportStatus.Failed]

export const isSettled = (status: ImportStatus) => SETTLED_STATUSES.includes(status)
